module.exports = __webpack_public_path__ + "img/Group 788four2.32c5536b.png";